import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { addMethod, string } from 'yup';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { ErrorBoundary } from 'react-error-boundary';
import AppRouter from "./services/router/router";
import Toasts from './components/library/Toasts';
import { logError } from "utils/logs";
import ServerError from './views/ServerError';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPhone, faClose, faCancel, faCircleExclamation, faCircleInfo, faEye, faCircleCheck, faArrowRight, faArrowLeft, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
library.add(faPhone, faClose, faCancel, faCircleExclamation, faCircleInfo, faEye, faCircleCheck, faArrowRight, faArrowLeft, faCalendarDays);
addMethod(string, 'phone', function (errorMessage, defaultCountry) {
    return this.test('phone', errorMessage, function (value) {
        if (value) {
            return defaultCountry != null
                ? isValidPhoneNumber(value, defaultCountry)
                : isValidPhoneNumber(value);
        }
        return false;
    });
});
function App() {
    return (_jsx("div", { className: "App", children: _jsxs(ErrorBoundary, { FallbackComponent: ServerError, onError: logError, children: [_jsx(AppRouter, {}), _jsx(Toasts, {})] }) }));
}
export default App;
